// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card--3qeuH","emptyStateMessage":"styles__emptyStateMessage--3jX-j"};